// eslint-disable-next-line no-useless-escape
export const validRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// links for 'other' websites & email
export const gitLink = 'https://github.com/Stevens-Mark'
export const linkedInLink ='https://www.linkedin.com/in/markspstevens/'
export const mail ='mailto:markspstevens@gmail.com'

export const skillsListOne = [
  {
    "title": "HTML5",
    "path": "../images/icons/html5.svg",
    "progress": 75,
  },
  {
    "title": "CSS3",
    "path": "../images/icons/css3.svg",
    "progress": 75,
  },
  {
    "title": "JS",
    "path": "../images/icons/javascript.svg",
    "progress": 50,
  },
  {
    "title": "React",
    "path": "../images/icons/react.svg",
    "progress": 75,
  },
  {
    "title": "SaSS",
    "path": "../images/icons/sass.svg",
    "progress": 50,
  },
]

export const skillsListTwo = [
  {
    "title": "Redux",
    "path": "../images/icons/redux.svg",
    "progress": 50,
  },
  {
    "title": "Boot Strap",
    "path": "../images/icons/bootstrap.svg",
    "progress": 50,
  },
  {
    "title": "Jest",
    "path": "../images/icons/jest.svg",
    "progress": 50,
  },
  {
    "title": "Figma",
    "path": "../images/icons/figma.svg",
    "progress": 50,
  },
  {
    "title": "Photo Shop",
    "path": "../images/icons/photoshop.svg",
    "progress": 75,
  },
]